import { Value } from '../types'

export const createEmptyValue = (): Value => {
  return {
    uuid: '',
    value: '',
    errors: [],
  }
}
